import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '@environments/environment'
import { CoverageApiResponse } from '../../models/coverages/coverage-api.model'
import { hasActualValue } from '@core/utils/form-utils'

@Injectable({
  providedIn: 'root'
})
export class CoverageService {
  private readonly http = inject(HttpClient)
  private readonly coverageApiUrl = environment.coverageApiUrl
  private readonly policyApiUrl = environment.policyApiUrl

  public getByPolicyId(policyId: string): Observable<CoverageApiResponse[]> {
    return this.http.get<CoverageApiResponse[]>(`${this.policyApiUrl}/${policyId}/coverages`)
  }

  public getById(uuid: string): Observable<CoverageApiResponse> {
    return this.http.get<CoverageApiResponse>(`${this.coverageApiUrl}/${uuid}`)
  }

  public create(coverage: CoverageApiResponse): Observable<CoverageApiResponse> {
    return this.http.post<CoverageApiResponse>(this.coverageApiUrl, coverage)
  }

  public update(coverage: CoverageApiResponse): Observable<CoverageApiResponse> {
    return this.http.put<CoverageApiResponse>(this.coverageApiUrl, coverage)
  }

  public save(coverage: CoverageApiResponse): Observable<CoverageApiResponse> {
    return hasActualValue(coverage.uuid)
      ? this.update(coverage)
      : this.create(coverage)
  }
}
